export default __webpack_public_path__ + "static/media/pen.0268fdba.svg";